export default __webpack_public_path__ + "locales/bg/Settings.json?hash=193338ac36f5d5c840a2a11a677a0026";